import { isJuisciShortUrlSession } from "../utils/juisciShortUrlSession";

const SHORT_URL_QUERY = "utm_source=juisci_short_url";

function withShortUrlQuery(path: string): string {
  if (!isJuisciShortUrlSession()) return path;
  return path + (path.includes("?") ? "&" : "?") + SHORT_URL_QUERY;
}

export function usePageLinks(currentRoomId: string | null) {
  function discoveryLink() {
    return currentRoomId ? `/room/discovery/${currentRoomId}` : "/discovery";
  }

  function searchLink() {
    return currentRoomId ? `/room/search/${currentRoomId}` : "/search";
  }

  function articleLink(article: { slug?: string }, forceRoomId = "") {
    return currentRoomId || forceRoomId
      ? `/room/post/${currentRoomId ?? forceRoomId}/${article.slug}`
      : `/post/${article.slug}`;
  }

  // The author page is global — an Author is the canonical person across the
  // whole platform (ORCID-resolved), so there is no room-scoped variant.
  function authorLink(author: { id: string }) {
    return `/author/${author.id}`;
  }

  function videoArticleLink(video: { slug?: string }, forceRoomId = "") {
    return currentRoomId || forceRoomId
      ? `/room/video/${currentRoomId ?? forceRoomId}/${video.slug}`
      : `/video/${video.slug}`;
  }

  function videoStoryLink(video: { slug?: string }, forceRoomId = "") {
    return currentRoomId || forceRoomId
      ? `/room/video/story/${currentRoomId ?? forceRoomId}/${video.slug}`
      : `/video/story/${video.slug}`;
  }

  function infographicLink(infographic: { slug?: string }, forceRoomId = "") {
    return currentRoomId || forceRoomId
      ? `/room/infographic/${currentRoomId ?? forceRoomId}/${infographic.slug}`
      : `/infographic/${infographic.slug}`;
  }

  function publicPlaylistLink(playlist: { id: string }, forceRoomId = "") {
    const playlistId = playlist?.id;
    return currentRoomId || forceRoomId
      ? `/room/playlist/${currentRoomId ?? forceRoomId}/${playlistId}`
      : `/playlist/public/${playlistId}`;
  }

  function chatWithPaperLink(article: { slug?: string }) {
    const path = currentRoomId
      ? `/room/post/${currentRoomId}/${article.slug}/chat`
      : `/post/${article.slug}/chat`;
    return withShortUrlQuery(path);
  }

  function chatWithPaperConversationLink(slug: string, conversationId: string) {
    const path = currentRoomId
      ? `/room/post/${currentRoomId}/${slug}/chat/conversation/${conversationId}`
      : `/post/${slug}/chat/conversation/${conversationId}`;
    return withShortUrlQuery(path);
  }

  function gptNewChatPageLink() {
    return currentRoomId
      ? `/room/gpt/chat/new/${currentRoomId}`
      : "/gpt/chat/new";
  }

  function gptConversationPageLink(conversationId: string) {
    return currentRoomId
      ? `/room/gpt/chat/conversation/${currentRoomId}/${conversationId}`
      : `/gpt/chat/conversation/${conversationId}`;
  }

  return {
    chatWithPaperLink,
    chatWithPaperConversationLink,
    discoveryLink,
    searchLink,
    articleLink,
    authorLink,

    videoArticleLink,
    videoStoryLink,
    infographicLink,
    publicPlaylistLink,
    gptNewChatPageLink,
    gptConversationPageLink,
  };
}
